import { normalizeTicketOfflineSoldOut } from "./eventOfflineAssignment";

export function unwrapMongoNumber(v) {
  if (v == null || v === "") return null;
  if (typeof v === "object") {
    if (v.$numberDecimal != null) return Number(v.$numberDecimal);
    if (v.$numberInt != null) return Number(v.$numberInt);
    if (v.$numberLong != null) return Number(v.$numberLong);
  }
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export function ticketTypeIdOf(tk) {
  const id = tk?._id ?? tk?.tickettypeid ?? tk?.ticketTypeId ?? tk?.id;
  return id != null && id !== "" ? String(id) : null;
}

export function isTicketTierSoldOut(tk) {
  if (!tk || typeof tk !== "object") return true;
  if (tk.soldout === true || tk.soldOut === true) return true;
  if (normalizeTicketOfflineSoldOut(tk)) return true;
  const total = unwrapMongoNumber(tk.totaltickets);
  const sold = unwrapMongoNumber(tk.ticketssold) ?? 0;
  if (total != null && total > 0 && sold >= total) return true;
  return false;
}

export function ticketTierRemaining(tk) {
  const total = unwrapMongoNumber(tk?.totaltickets);
  if (total == null || total <= 0) return null;
  const sold = unwrapMongoNumber(tk?.ticketssold) ?? 0;
  return Math.max(0, total - sold);
}

/**
 * Dropdown label: ticket type + optional description in brackets.
 * e.g. Guestlist (Complimentary guestlist), VVIP
 */
export function formatTicketTierLabel(tk, { soldOutLabel } = {}) {
  const type = String(tk?.tickettype ?? tk?.name ?? "Category").trim();
  const desc = String(tk?.categorydesc ?? tk?.categoryDesc ?? "").trim();

  let label = type;
  if (desc) label += ` (${desc})`;
  if (isTicketTierSoldOut(tk) && soldOutLabel) {
    label += ` (${soldOutLabel})`;
  }
  return label;
}

/**
 * All event ticket tiers (VIP, Regular, GA, etc.) — no price/name filter.
 * @param {Array} tickets
 * @param {{ soldOutLabel?: string }} [opts]
 */
export function buildEventTierOptions(tickets, opts = {}) {
  const { soldOutLabel } = opts;
  return (Array.isArray(tickets) ? tickets : [])
    .map((tk) => ({
      ticketTypeId: ticketTypeIdOf(tk),
      label: formatTicketTierLabel(tk, { soldOutLabel }),
      remaining: ticketTierRemaining(tk),
      soldOut: isTicketTierSoldOut(tk),
      raw: tk,
    }))
    .filter((o) => o.ticketTypeId);
}

/** First available (not sold out) tier, else empty. */
export function pickDefaultTicketTierId(tickets) {
  const options = buildEventTierOptions(tickets);
  const firstAvailable = options.find((o) => !o.soldOut);
  return firstAvailable ? firstAvailable.ticketTypeId : "";
}

export function findTicketTierById(tickets, ticketTypeId) {
  if (!ticketTypeId) return null;
  return (
    buildEventTierOptions(tickets).find(
      (o) => String(o.ticketTypeId) === String(ticketTypeId)
    )?.raw ?? null
  );
}

/** 10-digit Indian mobile starting with 6–9. */
export const INDIAN_MOBILE_PHONE_RE = /^[6-9]\d{9}$/;

export function parseIndianMobilePhoneInput(raw) {
  const trimmed = String(raw ?? "").trim();
  if (!trimmed) return null;
  let digits = trimmed.replace(/\D/g, "");
  if (digits.startsWith("91") && digits.length === 12) {
    digits = digits.slice(2);
  } else if (digits.startsWith("0") && digits.length === 11) {
    digits = digits.slice(1);
  }
  if (!INDIAN_MOBILE_PHONE_RE.test(digits)) {
    return null;
  }
  return digits;
}

export function isValidGuestlistPhone(raw) {
  return parseIndianMobilePhoneInput(raw) != null;
}
